import { isTokenValid } from "../helpers/token";
import { authenticate } from "./authenticate";
import { getAffiliateId } from "../helpers/affiliates";
import {
  HttpClient,
  HttpHeaders,
  HttpQueryParameters,
  HttpRequestMethod,
  RequestOptions,
} from "@rumble-it/common-lib/src/api/httpClient";

export const fetchData = async ({
  endpoint,
  queryParameters,
  data,
  headers,
  method = "GET",
  timeout,
}: {
  endpoint: string;
  queryParameters?: HttpQueryParameters;
  data?: any;
  headers?: HttpHeaders;
  method?: HttpRequestMethod;
  timeout?: number;
}) => {
  /**
   * Check if the token is valid. If not, authenticate the user.
   */
  let token = localStorage.getItem("accessToken");
  if (!isTokenValid(token)) {
    token = await authenticate();
  }
  if (token === null) {
    throw new Error("Failed to authenticate.");
  }

  /**
   * Check if token contains affiliate ID
   */
  const affiliateId = await getAffiliateId(token);
  if (affiliateId === null) {
    throw new Error("Failed to get affiliate ID.");
  }

  /**
   * Create a new instance of the HttpClient with the affiliate ID and token.
   */
  const httpClient = new HttpClient({
    affiliateId: affiliateId,
  }).setBearerToken(token);

  /**
   * Set the request options
   */
  const options: RequestOptions = {};
  if (queryParameters) options.params = queryParameters;
  if (headers) options.headers = headers;
  if (data) options.data = data;
  if (timeout) options.timeout = timeout;

  /**
   * Make the request
   */
  return await httpClient
    .request(
      method,
      endpoint.startsWith("/") ? endpoint : "/" + endpoint,
      options,
    )
    .then((response) => {
      if (response.data) {
        let data = response.data;

        if (data["@type"] === "Collection" && Array.isArray(data["member"])) {
          data = data["member"];
        }

        return {
          data,
        };
      } else return null;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
};
